export const SET_MIN_STAY = 'SET_MIN_STAY';

export interface ActionSetMinStay {
  type: typeof SET_MIN_STAY;
  minStay: number;
}

export type BookingsActions = ActionSetMinStay;

export default {
  SET_MIN_STAY,
};
